import api from './api';

/** What Kodahfy did — the one ledger (11 Sep 2026). */
const activityService = {
  async list(days = 30) {
    const res = await api.get('/activity', { params: { days } });
    return res.data?.data || { days, groups: [] };
  },
  async thisWeek() {
    const res = await api.get('/activity/this-week');
    return res.data?.data || { count: 0, items: [] };
  },
  /** The browser records a coach action it just executed. */
  async recordCoachAction({ summary, details = null, undo = null, link = null }) {
    const res = await api.post('/activity', { kind: 'coach_action', summary, details, undo, link });
    return res.data?.data?.id || null;
  },
  async undo(id) {
    const res = await api.post(`/activity/${id}/undo`);
    return res.data?.data;
  },
  async markUndone(id) {
    const res = await api.post(`/activity/${id}/undone`);
    return res.data?.data;
  }
};

export default activityService;
